import { makeStringDataField } from "@microsoft/oteljs";
export function AddExportPropertiesForUTel(payload, eventInfo) {
    eventInfo.exportName && payload.push(makeStringDataField("Export_Name", eventInfo.exportName));
}
